import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/browser';
import packageJson from '../../package.json';
import { Logger } from '../core/logger/Logger';

let enabled = false;

const captureException = (error: unknown, context?: Record<string, unknown>): void => {
  if (enabled) {
    if (context) {
      Sentry.withScope((scope) => {
        Object.entries(context).forEach(([key, value]) => {
          scope.setExtra(key, value);
        });
        Sentry.captureException(error);
      });
    } else {
      Sentry.captureException(error);
    }
  } else {
    Logger.error(error);
  }
};

const setSentryUser = (user: { id: string | number; email?: string } | null): void => {
  if (enabled) {
    Sentry.setUser(user ? { id: String(user.id), email: user.email } : null);
  }
};

const sentryInit = (): void => {
  if (process.env.REACT_APP_ENABLE_SENTRY === 'true') {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_URL,
      release: packageJson.version,
      environment: process.env.REACT_APP_ENVIRONMENT || 'unknown',
      integrations: [browserTracingIntegration()],
      tracesSampleRate: 0.2,
      beforeSend(event) {
        // Scrub cookies from request headers
        if (event.request?.cookies) {
          delete event.request.cookies;
        }
        if (event.request?.headers) {
          delete event.request.headers['Cookie'];
          delete event.request.headers['cookie'];
        }
        return event;
      }
    });

    enabled = true;
  }
};

export { captureException, sentryInit, setSentryUser };
